import workspaceQuery from 'graphql/queries/diary/DiaryAttributeWorkspaceQuery.graphql';
import listQuery from 'graphql/queries/diary/DiaryAttributeConfigListQuery.graphql';
import instanceQuery from 'graphql/queries/diary/DiaryAttributeConfigQuery.graphql';
import defaultQuery from 'graphql/queries/diary/DiaryAttributeConfigDefault.graphql';
import mutationQuery from 'graphql/mutations/diary/DiaryAttributeConfigMutation.graphql';
import fragment from 'graphql/fragments/diary/DiaryAttributeConfigFragment.graphql';

const DiaryAttributeConfig = {
  type: 'DiaryAttributeConfig',
  title: 'Task Attributes',
  formTitle: 'Task Attribute',
  formUrl: '/Diary/Attribute/Details/',
  workspaceUrl: '/Diary/Attribute/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  list: listQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'title',
  },
  fragment,
  screenReference: 'DIARY_EVENT_ATTRIBUTES',
};

export default DiaryAttributeConfig;
